__turbopack_context__.v({
  "deckCombos": "deckCombos-module-scss-module__T-ea7W__deckCombos",
});
